module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/E6Gf0U/tc-custom/9781426862960.jpg?1700958272348",
      "alt": "This image is the cover for the book Hard to Handle, The Charmed and Dangerous Series"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Hard to Handle, The Charmed and Dangerous Series\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("She had secrets in her eyes and lies on her lips, and Detective Gabe Connally knew that Meghan Patterson would give him more than a few sleepless nights. Still, with her young nephew a valuable witness, Gabe had to pursue Meghan. And even without the case, it would be impossible to forget the vulnerable woman trying to protect her family...."), _c('br'), _c('br'), _vm._v("While Meghan admired Gabe's persistence, she dared not let him get close enough to realize her nephew--her only remaining family--was psychic. Yet her own burning desire made it impossible to resist Gabe's persuasive ways....")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kylie Brant\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0